export const CONSIGNMENT_INBOUND_REQUEST_COLUMNS = [
  {
    name  : 'code',
    label : 'Code'
  },
  {
    name  : 'shipping_method',
    label : 'Shipping Method'
  },
  {
    name  : 'status',
    label : 'Status'
  },
  {
    name  : 'quantity',
    label : 'Inbound Quantity'
  },
  {
    name  : 'received_quantity',
    label : 'Received Qty'
  },
  {
    name  : 'received_weight',
    label : 'Received Weight'
  },
  {
    name  : 'received_at',
    label : 'Received Date'
  },
  {
    name  : 'dropoff_location_city',
    label : 'Dropoff Location'
  },
  {
    name  : 'scheduled_at',
    label : 'Scheduled At'
  },
  {
    name  : 'pickup_vehicle_type',
    label : 'Pickup Vehicle Type'
  },
  {
    name  : 'pickup_address',
    label : 'Pickup Address'
  },
  {
    name  : 'is_auto_discount',
    label : 'Is Auto Discount'
  }
]

export const SELLER_COLUMNS = [
  {
    name  : 'seller_name',
    label : 'Seller Name'
  },
  {
    name  : 'seller_code',
    label : 'Seller Code'
  },
  {
    name  : 'seller_email',
    label : 'Seller Email'
  },
  {
    name  : 'seller_phone',
    label : 'Seller Mobile'
  },
  {
    name  : 'notes',
    label : 'Notes'
  },
  {
    name  : 'seller_type',
    label : 'Seller Type'
  }
]
